// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../tolemac/pub/filter";
import * as dep_2 from "./contact";
import * as dep_3 from "./packages";
import * as dep_4 from "./contact_package";

export interface IPackageFile {
    id?: number;
    traineeAbandonedAt?: number;
    abandonIsComplete?: boolean;
    traineeCompletedAt?: number;
    completionIsComplete?: boolean;
    isDuplicate?: boolean;
    runningJobs?: number;
    contact?: dep_2.IContact;
    package?: dep_3.IPackage;
    contactPackage?: dep_4.IContactPackage;
    timeline?: ITimeline;
    applications?: IApplication[];

}
export class PackageFile implements IPackageFile {

    id?: number;
    traineeAbandonedAt?: number;
    abandonIsComplete?: boolean;
    traineeCompletedAt?: number;
    completionIsComplete?: boolean;
    isDuplicate?: boolean;
    runningJobs?: number;
    contact?: dep_2.Contact;
    package?: dep_3.Package;
    contactPackage?: dep_4.ContactPackage;
    timeline?: Timeline;
    applications?: Application[];

    constructor(data?: Partial<IPackageFile>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageFile extends Message implements PackageFile {

    constructor(data?: Partial<IPackageFile>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [15], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("traineeAbandonedAt" in data && data.traineeAbandonedAt != undefined) this.traineeAbandonedAt = data.traineeAbandonedAt;
            if ("abandonIsComplete" in data && data.abandonIsComplete != undefined) this.abandonIsComplete = data.abandonIsComplete;
            if ("traineeCompletedAt" in data && data.traineeCompletedAt != undefined) this.traineeCompletedAt = data.traineeCompletedAt;
            if ("completionIsComplete" in data && data.completionIsComplete != undefined) this.completionIsComplete = data.completionIsComplete;
            if ("isDuplicate" in data && data.isDuplicate != undefined) this.isDuplicate = data.isDuplicate;
            if ("runningJobs" in data && data.runningJobs != undefined) this.runningJobs = data.runningJobs;
            if ("contact" in data && data.contact != undefined) this.contact = new dep_2.MContact(data.contact);
            if ("package" in data && data.package != undefined) this.package = new dep_3.MPackage(data.package);
            if ("contactPackage" in data && data.contactPackage != undefined) this.contactPackage = new dep_4.MContactPackage(data.contactPackage);
            if ("timeline" in data && data.timeline != undefined) this.timeline = new MTimeline(data.timeline);
            if ("applications" in data && data.applications != undefined) this.applications = data.applications.map(d => new MApplication(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get traineeAbandonedAt(): number {
        return Message.getField(this, 2) as number;
    }
    set traineeAbandonedAt(value: number) {
        Message.setField(this, 2, value);
    }

    get abandonIsComplete(): boolean {
        return Message.getField(this, 3) as boolean;
    }
    set abandonIsComplete(value: boolean) {
        Message.setField(this, 3, value);
    }

    get traineeCompletedAt(): number {
        return Message.getField(this, 4) as number;
    }
    set traineeCompletedAt(value: number) {
        Message.setField(this, 4, value);
    }

    get completionIsComplete(): boolean {
        return Message.getField(this, 5) as boolean;
    }
    set completionIsComplete(value: boolean) {
        Message.setField(this, 5, value);
    }

    get isDuplicate(): boolean {
        return Message.getField(this, 6) as boolean;
    }
    set isDuplicate(value: boolean) {
        Message.setField(this, 6, value);
    }

    get runningJobs(): number {
        return Message.getField(this, 7) as number;
    }
    set runningJobs(value: number) {
        Message.setField(this, 7, value);
    }

    get contact(): dep_2.MContact {
        return Message.getWrapperField(this, dep_2.MContact, 10);
    }
    set contact(value: dep_2.MContact) {
        Message.setWrapperField(this, 10, value);
    }

    get package(): dep_3.MPackage {
        return Message.getWrapperField(this, dep_3.MPackage, 11);
    }
    set package(value: dep_3.MPackage) {
        Message.setWrapperField(this, 11, value);
    }

    get contactPackage(): dep_4.MContactPackage {
        return Message.getWrapperField(this, dep_4.MContactPackage, 13);
    }
    set contactPackage(value: dep_4.MContactPackage) {
        Message.setWrapperField(this, 13, value);
    }

    get timeline(): MTimeline {
        return Message.getWrapperField(this, MTimeline, 14);
    }
    set timeline(value: MTimeline) {
        Message.setWrapperField(this, 14, value);
    }

    get applications(): MApplication[] {
        return Message.getRepeatedWrapperField(this, MApplication, 15);
    }
    set applications(value: MApplication[]) {
        Message.setRepeatedWrapperField(this, 15, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageFile() : {} as PackageFile;
        if (this.id != undefined) data.id = this.id;
        if (this.traineeAbandonedAt != undefined) data.traineeAbandonedAt = this.traineeAbandonedAt;
        if (this.abandonIsComplete != undefined) data.abandonIsComplete = this.abandonIsComplete;
        if (this.traineeCompletedAt != undefined) data.traineeCompletedAt = this.traineeCompletedAt;
        if (this.completionIsComplete != undefined) data.completionIsComplete = this.completionIsComplete;
        if (this.isDuplicate != undefined) data.isDuplicate = this.isDuplicate;
        if (this.runningJobs != undefined) data.runningJobs = this.runningJobs;
        if (this.contact != undefined) data.contact = this.contact.toObject(includeInstance);
        if (this.package != undefined) data.package = this.package.toObject(includeInstance);
        if (this.contactPackage != undefined) data.contactPackage = this.contactPackage.toObject(includeInstance);
        if (this.timeline != undefined) data.timeline = this.timeline.toObject(includeInstance);
        if (this.applications.length) data.applications = this.applications.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.traineeAbandonedAt !== undefined) writer.writeInt64(2, this.traineeAbandonedAt);
                if (this.abandonIsComplete !== undefined) writer.writeBool(3, this.abandonIsComplete);
                if (this.traineeCompletedAt !== undefined) writer.writeInt64(4, this.traineeCompletedAt);
                if (this.completionIsComplete !== undefined) writer.writeBool(5, this.completionIsComplete);
                if (this.isDuplicate !== undefined) writer.writeBool(6, this.isDuplicate);
                if (this.runningJobs !== undefined) writer.writeInt32(7, this.runningJobs);
                if (this.contact !== undefined) writer.writeMessage(10, this.contact, () => this.contact.serialize(writer));
                if (this.package !== undefined) writer.writeMessage(11, this.package, () => this.package.serialize(writer));
                if (this.contactPackage !== undefined) writer.writeMessage(13, this.contactPackage, () => this.contactPackage.serialize(writer));
                if (this.timeline !== undefined) writer.writeMessage(14, this.timeline, () => this.timeline.serialize(writer));
                if (this.applications !== undefined) writer.writeRepeatedMessage(15, this.applications, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageFile): Uint8Array {
        return (data instanceof Message ? (data as MPackageFile) : new MPackageFile(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageFile {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageFile();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.traineeAbandonedAt = reader.readInt64();
                    break;
            case 3:
                    message.abandonIsComplete = reader.readBool();
                    break;
            case 4:
                    message.traineeCompletedAt = reader.readInt64();
                    break;
            case 5:
                    message.completionIsComplete = reader.readBool();
                    break;
            case 6:
                    message.isDuplicate = reader.readBool();
                    break;
            case 7:
                    message.runningJobs = reader.readInt32();
                    break;
            case 10:
                    reader.readMessage(message.contact, () => message.contact = dep_2.MContact.deserialize(reader));
                    break;
            case 11:
                    reader.readMessage(message.package, () => message.package = dep_3.MPackage.deserialize(reader));
                    break;
            case 13:
                    reader.readMessage(message.contactPackage, () => message.contactPackage = dep_4.MContactPackage.deserialize(reader));
                    break;
            case 14:
                    reader.readMessage(message.timeline, () => message.timeline = MTimeline.deserialize(reader));
                    break;
            case 15:
                    reader.readMessage(message.applications, () => Message.addToRepeatedWrapperField(message, 15, MApplication.deserialize(reader), MApplication));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageFile {
        return MPackageFile.deserializeBinaryFromReader(new MPackageFile(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageFile, reader: BinaryReader) {
        return Object.assign(msg, MPackageFile.deserialize(reader))
    };

}
export interface IApplication {
    id?: number;
    sentToApplicantAt?: number;
    sentToTrainerAt?: number;
    returnFromApplicantFor?: number;
    decisionDate?: number;
    canceledFor?: string;
    notified?: boolean;
    decision?: ApplicationDecision;
    status?: ApplicationStatus;
    assets?: IApplicationAsset[];

}
export class Application implements IApplication {

    id?: number;
    sentToApplicantAt?: number;
    sentToTrainerAt?: number;
    returnFromApplicantFor?: number;
    decisionDate?: number;
    canceledFor?: string;
    notified?: boolean;
    decision?: ApplicationDecision;
    status?: ApplicationStatus;
    assets?: ApplicationAsset[];

    constructor(data?: Partial<IApplication>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MApplication extends Message implements Application {

    constructor(data?: Partial<IApplication>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("sentToApplicantAt" in data && data.sentToApplicantAt != undefined) this.sentToApplicantAt = data.sentToApplicantAt;
            if ("sentToTrainerAt" in data && data.sentToTrainerAt != undefined) this.sentToTrainerAt = data.sentToTrainerAt;
            if ("returnFromApplicantFor" in data && data.returnFromApplicantFor != undefined) this.returnFromApplicantFor = data.returnFromApplicantFor;
            if ("decisionDate" in data && data.decisionDate != undefined) this.decisionDate = data.decisionDate;
            if ("canceledFor" in data && data.canceledFor != undefined) this.canceledFor = data.canceledFor;
            if ("notified" in data && data.notified != undefined) this.notified = data.notified;
            if ("decision" in data && data.decision != undefined) this.decision = data.decision;
            if ("status" in data && data.status != undefined) this.status = data.status;
            if ("assets" in data && data.assets != undefined) this.assets = data.assets.map(d => new MApplicationAsset(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get sentToApplicantAt(): number {
        return Message.getField(this, 2) as number;
    }
    set sentToApplicantAt(value: number) {
        Message.setField(this, 2, value);
    }

    get sentToTrainerAt(): number {
        return Message.getField(this, 3) as number;
    }
    set sentToTrainerAt(value: number) {
        Message.setField(this, 3, value);
    }

    get returnFromApplicantFor(): number {
        return Message.getField(this, 4) as number;
    }
    set returnFromApplicantFor(value: number) {
        Message.setField(this, 4, value);
    }

    get decisionDate(): number {
        return Message.getField(this, 5) as number;
    }
    set decisionDate(value: number) {
        Message.setField(this, 5, value);
    }

    get canceledFor(): string {
        return Message.getField(this, 6) as string;
    }
    set canceledFor(value: string) {
        Message.setField(this, 6, value);
    }

    get notified(): boolean {
        return Message.getField(this, 7) as boolean;
    }
    set notified(value: boolean) {
        Message.setField(this, 7, value);
    }

    get decision(): ApplicationDecision {
        return Message.getField(this, 8) as ApplicationDecision;
    }
    set decision(value: ApplicationDecision) {
        Message.setField(this, 8, value);
    }

    get status(): ApplicationStatus {
        return Message.getField(this, 9) as ApplicationStatus;
    }
    set status(value: ApplicationStatus) {
        Message.setField(this, 9, value);
    }

    get assets(): MApplicationAsset[] {
        return Message.getRepeatedWrapperField(this, MApplicationAsset, 10);
    }
    set assets(value: MApplicationAsset[]) {
        Message.setRepeatedWrapperField(this, 10, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Application() : {} as Application;
        if (this.id != undefined) data.id = this.id;
        if (this.sentToApplicantAt != undefined) data.sentToApplicantAt = this.sentToApplicantAt;
        if (this.sentToTrainerAt != undefined) data.sentToTrainerAt = this.sentToTrainerAt;
        if (this.returnFromApplicantFor != undefined) data.returnFromApplicantFor = this.returnFromApplicantFor;
        if (this.decisionDate != undefined) data.decisionDate = this.decisionDate;
        if (this.canceledFor != undefined) data.canceledFor = this.canceledFor;
        if (this.notified != undefined) data.notified = this.notified;
        if (this.decision != undefined) data.decision = this.decision;
        if (this.status != undefined) data.status = this.status;
        if (this.assets.length) data.assets = this.assets.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.sentToApplicantAt !== undefined) writer.writeInt64(2, this.sentToApplicantAt);
                if (this.sentToTrainerAt !== undefined) writer.writeInt64(3, this.sentToTrainerAt);
                if (this.returnFromApplicantFor !== undefined) writer.writeInt64(4, this.returnFromApplicantFor);
                if (this.decisionDate !== undefined) writer.writeInt64(5, this.decisionDate);
                if (this.canceledFor !== undefined) writer.writeString(6, this.canceledFor);
                if (this.notified !== undefined) writer.writeBool(7, this.notified);
                if (this.decision !== undefined) writer.writeEnum(8, this.decision);
                if (this.status !== undefined) writer.writeEnum(9, this.status);
                if (this.assets !== undefined) writer.writeRepeatedMessage(10, this.assets, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IApplication): Uint8Array {
        return (data instanceof Message ? (data as MApplication) : new MApplication(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MApplication {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MApplication();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.sentToApplicantAt = reader.readInt64();
                    break;
            case 3:
                    message.sentToTrainerAt = reader.readInt64();
                    break;
            case 4:
                    message.returnFromApplicantFor = reader.readInt64();
                    break;
            case 5:
                    message.decisionDate = reader.readInt64();
                    break;
            case 6:
                    message.canceledFor = reader.readString();
                    break;
            case 7:
                    message.notified = reader.readBool();
                    break;
            case 8:
                    message.decision = reader.readEnum();
                    break;
            case 9:
                    message.status = reader.readEnum();
                    break;
            case 10:
                    reader.readMessage(message.assets, () => Message.addToRepeatedWrapperField(message, 10, MApplicationAsset.deserialize(reader), MApplicationAsset));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MApplication {
        return MApplication.deserializeBinaryFromReader(new MApplication(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MApplication, reader: BinaryReader) {
        return Object.assign(msg, MApplication.deserialize(reader))
    };

}
export enum ApplicationDecision {
    UNDEFINED_ApplicationDecision = 0,
    WAITING = 1,
    ADMITTED = 2,
    REJECTED = 3,
    CONDITIONALLY_ADMITTED = 4,
}
export enum ApplicationStatus {
    UNDEFINED_ApplicationStatus = 0,
    ACTIVE = 1,
    CANCELED = 2,
}
export interface IApplicationAsset {
    id?: number;
    category?: ApplicationAssetCategory;
    createdAt?: number;
    updatedAt?: number;

}
export class ApplicationAsset implements IApplicationAsset {

    id?: number;
    category?: ApplicationAssetCategory;
    createdAt?: number;
    updatedAt?: number;

    constructor(data?: Partial<IApplicationAsset>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MApplicationAsset extends Message implements ApplicationAsset {

    constructor(data?: Partial<IApplicationAsset>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("category" in data && data.category != undefined) this.category = data.category;
            if ("createdAt" in data && data.createdAt != undefined) this.createdAt = data.createdAt;
            if ("updatedAt" in data && data.updatedAt != undefined) this.updatedAt = data.updatedAt;
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get category(): ApplicationAssetCategory {
        return Message.getField(this, 3) as ApplicationAssetCategory;
    }
    set category(value: ApplicationAssetCategory) {
        Message.setField(this, 3, value);
    }

    get createdAt(): number {
        return Message.getField(this, 4) as number;
    }
    set createdAt(value: number) {
        Message.setField(this, 4, value);
    }

    get updatedAt(): number {
        return Message.getField(this, 5) as number;
    }
    set updatedAt(value: number) {
        Message.setField(this, 5, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new ApplicationAsset() : {} as ApplicationAsset;
        if (this.id != undefined) data.id = this.id;
        if (this.category != undefined) data.category = this.category;
        if (this.createdAt != undefined) data.createdAt = this.createdAt;
        if (this.updatedAt != undefined) data.updatedAt = this.updatedAt;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.category !== undefined) writer.writeEnum(3, this.category);
                if (this.createdAt !== undefined) writer.writeInt64(4, this.createdAt);
                if (this.updatedAt !== undefined) writer.writeInt64(5, this.updatedAt);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IApplicationAsset): Uint8Array {
        return (data instanceof Message ? (data as MApplicationAsset) : new MApplicationAsset(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MApplicationAsset {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MApplicationAsset();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 3:
                    message.category = reader.readEnum();
                    break;
            case 4:
                    message.createdAt = reader.readInt64();
                    break;
            case 5:
                    message.updatedAt = reader.readInt64();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MApplicationAsset {
        return MApplicationAsset.deserializeBinaryFromReader(new MApplicationAsset(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MApplicationAsset, reader: BinaryReader) {
        return Object.assign(msg, MApplicationAsset.deserialize(reader))
    };

}
export enum ApplicationAssetCategory {
    UNDEFINED_ApplicationAssetCategory = 0,
    CV = 1,
    PP = 2,
    TEST = 3,
    RTEST = 4,
}
export interface ITimeline {
    id?: number;
    timespans?: ITimespan[];

}
export class Timeline implements ITimeline {

    id?: number;
    timespans?: Timespan[];

    constructor(data?: Partial<ITimeline>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimeline extends Message implements Timeline {

    constructor(data?: Partial<ITimeline>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [2], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("timespans" in data && data.timespans != undefined) this.timespans = data.timespans.map(d => new MTimespan(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get timespans(): MTimespan[] {
        return Message.getRepeatedWrapperField(this, MTimespan, 2);
    }
    set timespans(value: MTimespan[]) {
        Message.setRepeatedWrapperField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Timeline() : {} as Timeline;
        if (this.id != undefined) data.id = this.id;
        if (this.timespans.length) data.timespans = this.timespans.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.timespans !== undefined) writer.writeRepeatedMessage(2, this.timespans, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimeline): Uint8Array {
        return (data instanceof Message ? (data as MTimeline) : new MTimeline(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimeline {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimeline();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    reader.readMessage(message.timespans, () => Message.addToRepeatedWrapperField(message, 2, MTimespan.deserialize(reader), MTimespan));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimeline {
        return MTimeline.deserializeBinaryFromReader(new MTimeline(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimeline, reader: BinaryReader) {
        return Object.assign(msg, MTimeline.deserialize(reader))
    };

}
export interface ITimespan {
    id?: number;
    isSignedUp?: boolean;
    runningJobs?: number;
    timespanPackages?: ITimespanPackage;

}
export class Timespan implements ITimespan {

    id?: number;
    isSignedUp?: boolean;
    runningJobs?: number;
    timespanPackages?: TimespanPackage;

    constructor(data?: Partial<ITimespan>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimespan extends Message implements Timespan {

    constructor(data?: Partial<ITimespan>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("isSignedUp" in data && data.isSignedUp != undefined) this.isSignedUp = data.isSignedUp;
            if ("runningJobs" in data && data.runningJobs != undefined) this.runningJobs = data.runningJobs;
            if ("timespanPackages" in data && data.timespanPackages != undefined) this.timespanPackages = new MTimespanPackage(data.timespanPackages);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get isSignedUp(): boolean {
        return Message.getField(this, 2) as boolean;
    }
    set isSignedUp(value: boolean) {
        Message.setField(this, 2, value);
    }

    get runningJobs(): number {
        return Message.getField(this, 3) as number;
    }
    set runningJobs(value: number) {
        Message.setField(this, 3, value);
    }

    get timespanPackages(): MTimespanPackage {
        return Message.getWrapperField(this, MTimespanPackage, 20);
    }
    set timespanPackages(value: MTimespanPackage) {
        Message.setWrapperField(this, 20, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Timespan() : {} as Timespan;
        if (this.id != undefined) data.id = this.id;
        if (this.isSignedUp != undefined) data.isSignedUp = this.isSignedUp;
        if (this.runningJobs != undefined) data.runningJobs = this.runningJobs;
        if (this.timespanPackages != undefined) data.timespanPackages = this.timespanPackages.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.isSignedUp !== undefined) writer.writeBool(2, this.isSignedUp);
                if (this.runningJobs !== undefined) writer.writeInt32(3, this.runningJobs);
                if (this.timespanPackages !== undefined) writer.writeMessage(20, this.timespanPackages, () => this.timespanPackages.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimespan): Uint8Array {
        return (data instanceof Message ? (data as MTimespan) : new MTimespan(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimespan {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimespan();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.isSignedUp = reader.readBool();
                    break;
            case 3:
                    message.runningJobs = reader.readInt32();
                    break;
            case 20:
                    reader.readMessage(message.timespanPackages, () => message.timespanPackages = MTimespanPackage.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimespan {
        return MTimespan.deserializeBinaryFromReader(new MTimespan(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimespan, reader: BinaryReader) {
        return Object.assign(msg, MTimespan.deserialize(reader))
    };

}
export interface ITimespanPackage {
    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    timespanTrainings?: ITimespanTraining[];

}
export class TimespanPackage implements ITimespanPackage {

    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    timespanTrainings?: TimespanTraining[];

    constructor(data?: Partial<ITimespanPackage>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimespanPackage extends Message implements TimespanPackage {

    constructor(data?: Partial<ITimespanPackage>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [20], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("startAt" in data && data.startAt != undefined) this.startAt = data.startAt;
            if ("endAt" in data && data.endAt != undefined) this.endAt = data.endAt;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("timespanTrainings" in data && data.timespanTrainings != undefined) this.timespanTrainings = data.timespanTrainings.map(d => new MTimespanTraining(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get startAt(): number {
        return Message.getField(this, 2) as number;
    }
    set startAt(value: number) {
        Message.setField(this, 2, value);
    }

    get endAt(): number {
        return Message.getField(this, 3) as number;
    }
    set endAt(value: number) {
        Message.setField(this, 3, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 4) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 4, value);
    }

    get timespanTrainings(): MTimespanTraining[] {
        return Message.getRepeatedWrapperField(this, MTimespanTraining, 20);
    }
    set timespanTrainings(value: MTimespanTraining[]) {
        Message.setRepeatedWrapperField(this, 20, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new TimespanPackage() : {} as TimespanPackage;
        if (this.id != undefined) data.id = this.id;
        if (this.startAt != undefined) data.startAt = this.startAt;
        if (this.endAt != undefined) data.endAt = this.endAt;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.timespanTrainings.length) data.timespanTrainings = this.timespanTrainings.map(d => d.toObject(includeInstance));

        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.startAt !== undefined) writer.writeInt64(2, this.startAt);
                if (this.endAt !== undefined) writer.writeInt64(3, this.endAt);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(4, this.rawWorkDuration);
                if (this.timespanTrainings !== undefined) writer.writeRepeatedMessage(20, this.timespanTrainings, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimespanPackage): Uint8Array {
        return (data instanceof Message ? (data as MTimespanPackage) : new MTimespanPackage(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimespanPackage {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimespanPackage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.startAt = reader.readInt64();
                    break;
            case 3:
                    message.endAt = reader.readInt64();
                    break;
            case 4:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 20:
                    reader.readMessage(message.timespanTrainings, () => Message.addToRepeatedWrapperField(message, 20, MTimespanTraining.deserialize(reader), MTimespanTraining));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimespanPackage {
        return MTimespanPackage.deserializeBinaryFromReader(new MTimespanPackage(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimespanPackage, reader: BinaryReader) {
        return Object.assign(msg, MTimespanPackage.deserialize(reader))
    };

}
export interface ITimespanTraining {
    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    rawWeekDuration?: number;
    timespanTrainingModules?: ITimespanTrainingModule[];
    /**
     * myedvenn.packages.PackageTraining package_training = 21;
     */
    contactTraining?: dep_4.IContactTraining;

}
export class TimespanTraining implements ITimespanTraining {

    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    rawWeekDuration?: number;
    timespanTrainingModules?: TimespanTrainingModule[];
    contactTraining?: dep_4.ContactTraining;

    constructor(data?: Partial<ITimespanTraining>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimespanTraining extends Message implements TimespanTraining {

    constructor(data?: Partial<ITimespanTraining>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [20], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("startAt" in data && data.startAt != undefined) this.startAt = data.startAt;
            if ("endAt" in data && data.endAt != undefined) this.endAt = data.endAt;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("rawWeekDuration" in data && data.rawWeekDuration != undefined) this.rawWeekDuration = data.rawWeekDuration;
            if ("timespanTrainingModules" in data && data.timespanTrainingModules != undefined) this.timespanTrainingModules = data.timespanTrainingModules.map(d => new MTimespanTrainingModule(d));
            if ("contactTraining" in data && data.contactTraining != undefined) this.contactTraining = new dep_4.MContactTraining(data.contactTraining);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get startAt(): number {
        return Message.getField(this, 2) as number;
    }
    set startAt(value: number) {
        Message.setField(this, 2, value);
    }

    get endAt(): number {
        return Message.getField(this, 3) as number;
    }
    set endAt(value: number) {
        Message.setField(this, 3, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 4) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 4, value);
    }

    get rawWeekDuration(): number {
        return Message.getField(this, 5) as number;
    }
    set rawWeekDuration(value: number) {
        Message.setField(this, 5, value);
    }

    get timespanTrainingModules(): MTimespanTrainingModule[] {
        return Message.getRepeatedWrapperField(this, MTimespanTrainingModule, 20);
    }
    set timespanTrainingModules(value: MTimespanTrainingModule[]) {
        Message.setRepeatedWrapperField(this, 20, value);
    }

    get contactTraining(): dep_4.MContactTraining {
        return Message.getWrapperField(this, dep_4.MContactTraining, 21);
    }
    set contactTraining(value: dep_4.MContactTraining) {
        Message.setWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new TimespanTraining() : {} as TimespanTraining;
        if (this.id != undefined) data.id = this.id;
        if (this.startAt != undefined) data.startAt = this.startAt;
        if (this.endAt != undefined) data.endAt = this.endAt;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.rawWeekDuration != undefined) data.rawWeekDuration = this.rawWeekDuration;
        if (this.timespanTrainingModules.length) data.timespanTrainingModules = this.timespanTrainingModules.map(d => d.toObject(includeInstance));

        if (this.contactTraining != undefined) data.contactTraining = this.contactTraining.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.startAt !== undefined) writer.writeInt64(2, this.startAt);
                if (this.endAt !== undefined) writer.writeInt64(3, this.endAt);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(4, this.rawWorkDuration);
                if (this.rawWeekDuration !== undefined) writer.writeInt32(5, this.rawWeekDuration);
                if (this.timespanTrainingModules !== undefined) writer.writeRepeatedMessage(20, this.timespanTrainingModules, (i) => i.serialize(writer));
                if (this.contactTraining !== undefined) writer.writeMessage(21, this.contactTraining, () => this.contactTraining.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimespanTraining): Uint8Array {
        return (data instanceof Message ? (data as MTimespanTraining) : new MTimespanTraining(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimespanTraining {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimespanTraining();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.startAt = reader.readInt64();
                    break;
            case 3:
                    message.endAt = reader.readInt64();
                    break;
            case 4:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 5:
                    message.rawWeekDuration = reader.readInt32();
                    break;
            case 20:
                    reader.readMessage(message.timespanTrainingModules, () => Message.addToRepeatedWrapperField(message, 20, MTimespanTrainingModule.deserialize(reader), MTimespanTrainingModule));
                    break;
            case 21:
                    reader.readMessage(message.contactTraining, () => message.contactTraining = dep_4.MContactTraining.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimespanTraining {
        return MTimespanTraining.deserializeBinaryFromReader(new MTimespanTraining(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimespanTraining, reader: BinaryReader) {
        return Object.assign(msg, MTimespanTraining.deserialize(reader))
    };

}
export interface ITimespanTrainingModule {
    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    timespanTrainingSections?: ITimespanTrainingSection[];
    /**
     * myedvenn.packages.PackageTrainingModule package_training_module = 21;
     */
    contactTrainingModule?: dep_4.IContactTrainingModule;

}
export class TimespanTrainingModule implements ITimespanTrainingModule {

    id?: number;
    startAt?: number;
    endAt?: number;
    rawWorkDuration?: number;
    timespanTrainingSections?: TimespanTrainingSection[];
    contactTrainingModule?: dep_4.ContactTrainingModule;

    constructor(data?: Partial<ITimespanTrainingModule>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimespanTrainingModule extends Message implements TimespanTrainingModule {

    constructor(data?: Partial<ITimespanTrainingModule>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [20], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("startAt" in data && data.startAt != undefined) this.startAt = data.startAt;
            if ("endAt" in data && data.endAt != undefined) this.endAt = data.endAt;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("timespanTrainingSections" in data && data.timespanTrainingSections != undefined) this.timespanTrainingSections = data.timespanTrainingSections.map(d => new MTimespanTrainingSection(d));
            if ("contactTrainingModule" in data && data.contactTrainingModule != undefined) this.contactTrainingModule = new dep_4.MContactTrainingModule(data.contactTrainingModule);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get startAt(): number {
        return Message.getField(this, 2) as number;
    }
    set startAt(value: number) {
        Message.setField(this, 2, value);
    }

    get endAt(): number {
        return Message.getField(this, 3) as number;
    }
    set endAt(value: number) {
        Message.setField(this, 3, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 4) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 4, value);
    }

    get timespanTrainingSections(): MTimespanTrainingSection[] {
        return Message.getRepeatedWrapperField(this, MTimespanTrainingSection, 20);
    }
    set timespanTrainingSections(value: MTimespanTrainingSection[]) {
        Message.setRepeatedWrapperField(this, 20, value);
    }

    get contactTrainingModule(): dep_4.MContactTrainingModule {
        return Message.getWrapperField(this, dep_4.MContactTrainingModule, 21);
    }
    set contactTrainingModule(value: dep_4.MContactTrainingModule) {
        Message.setWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new TimespanTrainingModule() : {} as TimespanTrainingModule;
        if (this.id != undefined) data.id = this.id;
        if (this.startAt != undefined) data.startAt = this.startAt;
        if (this.endAt != undefined) data.endAt = this.endAt;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.timespanTrainingSections.length) data.timespanTrainingSections = this.timespanTrainingSections.map(d => d.toObject(includeInstance));

        if (this.contactTrainingModule != undefined) data.contactTrainingModule = this.contactTrainingModule.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.startAt !== undefined) writer.writeInt64(2, this.startAt);
                if (this.endAt !== undefined) writer.writeInt64(3, this.endAt);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(4, this.rawWorkDuration);
                if (this.timespanTrainingSections !== undefined) writer.writeRepeatedMessage(20, this.timespanTrainingSections, (i) => i.serialize(writer));
                if (this.contactTrainingModule !== undefined) writer.writeMessage(21, this.contactTrainingModule, () => this.contactTrainingModule.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimespanTrainingModule): Uint8Array {
        return (data instanceof Message ? (data as MTimespanTrainingModule) : new MTimespanTrainingModule(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimespanTrainingModule {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimespanTrainingModule();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.startAt = reader.readInt64();
                    break;
            case 3:
                    message.endAt = reader.readInt64();
                    break;
            case 4:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 20:
                    reader.readMessage(message.timespanTrainingSections, () => Message.addToRepeatedWrapperField(message, 20, MTimespanTrainingSection.deserialize(reader), MTimespanTrainingSection));
                    break;
            case 21:
                    reader.readMessage(message.contactTrainingModule, () => message.contactTrainingModule = dep_4.MContactTrainingModule.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimespanTrainingModule {
        return MTimespanTrainingModule.deserializeBinaryFromReader(new MTimespanTrainingModule(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimespanTrainingModule, reader: BinaryReader) {
        return Object.assign(msg, MTimespanTrainingModule.deserialize(reader))
    };

}
export interface ITimespanTrainingSection {
    id?: number;
    rawWorkDuration?: number;
    /**
     * myedvenn.packages.PackageTrainingSection package_training_section = 21;
     */
    contactTrainingSection?: dep_4.IContactTrainingSection;

}
export class TimespanTrainingSection implements ITimespanTrainingSection {

    id?: number;
    rawWorkDuration?: number;
    contactTrainingSection?: dep_4.ContactTrainingSection;

    constructor(data?: Partial<ITimespanTrainingSection>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MTimespanTrainingSection extends Message implements TimespanTrainingSection {

    constructor(data?: Partial<ITimespanTrainingSection>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("contactTrainingSection" in data && data.contactTrainingSection != undefined) this.contactTrainingSection = new dep_4.MContactTrainingSection(data.contactTrainingSection);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 2) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 2, value);
    }

    get contactTrainingSection(): dep_4.MContactTrainingSection {
        return Message.getWrapperField(this, dep_4.MContactTrainingSection, 21);
    }
    set contactTrainingSection(value: dep_4.MContactTrainingSection) {
        Message.setWrapperField(this, 21, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new TimespanTrainingSection() : {} as TimespanTrainingSection;
        if (this.id != undefined) data.id = this.id;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.contactTrainingSection != undefined) data.contactTrainingSection = this.contactTrainingSection.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(2, this.rawWorkDuration);
                if (this.contactTrainingSection !== undefined) writer.writeMessage(21, this.contactTrainingSection, () => this.contactTrainingSection.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: ITimespanTrainingSection): Uint8Array {
        return (data instanceof Message ? (data as MTimespanTrainingSection) : new MTimespanTrainingSection(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MTimespanTrainingSection {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MTimespanTrainingSection();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 21:
                    reader.readMessage(message.contactTrainingSection, () => message.contactTrainingSection = dep_4.MContactTrainingSection.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MTimespanTrainingSection {
        return MTimespanTrainingSection.deserializeBinaryFromReader(new MTimespanTrainingSection(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MTimespanTrainingSection, reader: BinaryReader) {
        return Object.assign(msg, MTimespanTrainingSection.deserialize(reader))
    };

}
export interface IPackageFiles {
    values?: IPackageFile[];
    count?: number;

}
export class PackageFiles implements IPackageFiles {

    values: PackageFile[];
    count?: number;

    constructor(data?: Partial<IPackageFiles>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageFiles extends Message implements PackageFiles {

    constructor(data?: Partial<IPackageFiles>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MPackageFile(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MPackageFile[] {
        return Message.getRepeatedWrapperField(this, MPackageFile, 1);
    }
    set values(value: MPackageFile[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageFiles() : {} as PackageFiles;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageFiles): Uint8Array {
        return (data instanceof Message ? (data as MPackageFiles) : new MPackageFiles(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageFiles {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageFiles();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MPackageFile.deserialize(reader), MPackageFile));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageFiles {
        return MPackageFiles.deserializeBinaryFromReader(new MPackageFiles(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageFiles, reader: BinaryReader) {
        return Object.assign(msg, MPackageFiles.deserialize(reader))
    };

}
                        




export default () => {}